import { Link } from "react-router-dom"
import React from "react"
import { useConnectedUserDeclarationDetails } from "../ConnectedPersonnelDeclarationDetails"

const Footer = () => {
     const context = useConnectedUserDeclarationDetails()

     return (
          <>
               <div className="d-none d-sm-flex justify-content-between">
                    <div>
                         <Link to="/personnel/mes-activites/declarations " className={`btn btn-sm btn-light-primary me-2`}>
                              <i className={"fas fa-list-dots me-2 align-middle"} /> Retour aux déclarations
                         </Link>
                         <button type="button" className="btn btn-sm btn-light-primary me-3" onClick={() => context.setCurrentStepHeader("cra")}>
                              <span className={"fas fa-arrow-left fs-3 me-1 align-middle"} /> CRA
                         </button>
                    </div>

                    <button
                         type="button"
                         className="btn btn-sm btn-primary"
                         onClick={() => {
                              context.setCurrentStepHeader(context.enCoursDeRectificationEnabledDepuisRecapitulatif ? "recap" : "ticket_resto")
                              context.setEnCoursDeRectificationEnabledDepuisRecapitulatif(false)
                         }}
                    >
                         {context.enCoursDeRectificationEnabledDepuisRecapitulatif ? "Récapitulatif" : "TR"}
                         <span className={"fas fa-arrow-right fs-3 ms-1 align-middle"} />
                    </button>
               </div>

               <div className="d-flex d-sm-none flex-column">
                    <div className={"mb-3"}>
                         <button type="button" className="btn btn-sm btn-light-primary me-3" onClick={() => context.setCurrentStepHeader("cra")}>
                              <span className={"fas fa-arrow-left fs-3 me-1 align-middle"} /> CRA
                         </button>
                         <button
                              type="button"
                              className="btn btn-sm btn-primary float-end"
                              onClick={() => {
                                   context.setCurrentStepHeader(context.enCoursDeRectificationEnabledDepuisRecapitulatif ? "recap" : "ticket_resto")
                                   context.setEnCoursDeRectificationEnabledDepuisRecapitulatif(false)
                              }}
                         >
                              {context.enCoursDeRectificationEnabledDepuisRecapitulatif ? "Récapitulatif" : "TR"}
                              <span className={"fas fa-arrow-right fs-3 ms-1 align-middle"} />
                         </button>
                    </div>

                    <Link to="/personnel/mes-activites/declarations " className={`btn btn-sm btn-light-primary`}>
                         <span className={"fas fa-list-dots fs-1 me-3 align-middle"} /> Retour aux déclarations
                    </Link>
               </div>
          </>
     )
}

export default Footer
